import { apiClient } from "../../lib";

export const commentsAndlogs = {
    getLogs: async (params?: Record<string, any>): Promise<any> => {
        const searchParams = new URLSearchParams();
        Object.entries(params || {}).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                value.forEach(v => {
                    if (v) searchParams.append(key, String(v));
                });
            } else if (value) {
                searchParams.append(key, String(value));
            }
        });
        const query = searchParams.toString();
        const response = await apiClient.get(`/activity-log?${query}`);
        return response.data;
    },
    getComments: async (params?: Record<string, any>): Promise<any> => {
        const searchParams = new URLSearchParams();
        Object.entries(params || {}).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                value.forEach(v => {
                    if (v) searchParams.append(key, String(v));
                });
            } else if (value) {
                searchParams.append(key, String(value));
            }
        });
        const query = searchParams.toString();
        const response = await apiClient.get(`/comments?${query}`);
        return response.data;
    },
    postComments: async (payload?: Record<string, any>): Promise<any> => {
        const response = await apiClient.post(`/comments`, payload);
        return response.data;
    }
};